import { useMutation } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { ProductsApiAdapter } from '../adapters/ProductsApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const apiAdapter = new ProductsApiAdapter(httpClient);

export const useExportProductsExcel = () =>
  useMutation<string, Error, any>({
    mutationFn: (filters) => apiAdapter.exportProductsExcel(filters),
  });
